const HTTP_SCHEMES = ["https://", "http://"];

const stripScheme = (value) => {
  const lowered = value.toLowerCase();
  const prefix = HTTP_SCHEMES.find((scheme) => lowered.startsWith(scheme));
  return prefix ? value.slice(prefix.length) : value;
};

const hostFromUrlOrDomain = (value) => {
  let remainder = stripScheme(value);
  if (remainder.startsWith("//")) {
    remainder = remainder.slice(2);
  }
  let host = remainder.split("/")[0].split("?")[0].split("#")[0];
  if (host.includes("@")) {
    host = host.split("@").pop();
  }
  return host.split(":")[0].trim().replace(/^\.+|\.+$/g, "");
};

export const sanitizeDomainName = (value) => {
  if (value == null) {
    return value;
  }
  const raw = value.trim();
  if (!raw) {
    return raw;
  }
  const host = hostFromUrlOrDomain(raw);
  if (host && host.includes(".")) {
    return host;
  }
  return raw;
};
